import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getGroupPrice } from '../../Reducers/Configurator/Selecctors';
import Typography from '@material-ui/core/Typography';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Divider } from '@material-ui/core';
import { Availability } from '../Availability';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      paddingBottom: 20,
    },
    priceContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'end',
      paddingTop: 10,
    },
    divider: {
      backgroundColor: 'black',
    },
    priceText: {
      textAlign: 'end',
      lineHeight: 1.2,
      paddingRight: 20,
    },
    price: {
      textAlign: 'end',
      lineHeight: 1.2,
      paddingRight: 10,
      fontSize: 20,
      fontWeight: 'bold',
    },
    availability: {
      paddingRight: 10,
      textAlign: 'right',
    },
  };
});

const GroupPrice = ({ optionclassification }) => {
  const classes = useStyles();
  const price = useSelector((state) => getGroupPrice(state, optionclassification.identifier));

  return (
    <div className={classes.root}>
      <Divider className={classes.divider} />
      <div className={classes.priceContainer}>
        <Typography className={classes.priceText}>{t('groupPrice.price')}</Typography>
        <Typography variant="h5" className={classes.price}>
          {price}
        </Typography>
      </div>
      <Availability className={classes.availability} groupIdentifier={optionclassification.identifier} />
    </div>
  );
};

export default GroupPrice;
